module.exports = __webpack_public_path__ + "themes/mf/img/logo-game.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/logo-game.png
// module id = 75
// module chunks = 3